// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.application-form {
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  font-family: 'Josefin Sans', sans-serif;
}

.form-header {
  text-align: center;
  margin-bottom: 2rem;
}

.form-header h2 {
  font-size: 2rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 1rem;
}

.form-header p {
  color: #666;
  line-height: 1.6;
}

.form-section {
  margin-bottom: 2rem;
  padding: 2rem;
  background: white;
  border-radius: 8px;
  border: 1px solid #eee;
}

.form-section h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 1rem;
  border-bottom: 2px solid #eee;
  padding-bottom: 0.5rem;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

label {
  font-weight: 500;
  margin-bottom: 0.5rem;
  color: #333;
}

input[type="text"],
input[type="email"],
input[type="tel"],
select,
textarea {
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  font-family: 'Josefin Sans', sans-serif;
  transition: border-color 0.3s ease;
}

input[type="text"]:focus,
input[type="email"]:focus,
input[type="tel"]:focus,
select:focus,
textarea:focus {
  outline: none;
  border-color: #DEB241;
  box-shadow: 0 0 0 1px #DEB241;
}

textarea {
  width: 100%;
  min-height: 120px;
  padding: 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-family: 'Josefin Sans', sans-serif;
  font-size: 1rem;
  resize: vertical;
}

.checkbox-grid {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
}

.checkbox-group {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
}

.checkbox-group input[type="checkbox"] {
  width: 20px;
  height: 20px;
  margin-top: 0.2rem;
  border: 2px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  accent-color: #526015;
}

.checkbox-group input[type="checkbox"]:checked {
  background-color: #526015;
  border-color: #526015;
}

.checkbox-group input[type="checkbox"]:checked + label {
  color: #526015;
  font-weight: 500;
}

.checkbox-group label {
  font-weight: normal;
  line-height: 1.5;
  color: #333;
  cursor: pointer;
}

.certification {
  margin-top: 2rem;
  padding: 1.5rem;
  background: #f9f9f9;
  border-radius: 4px;
}

.submit-button {
  display: block;
  width: 100%;
  padding: 1rem;
  background: var(--color-gold);
  color: #333;
  border: none;
  border-radius: 25px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 2rem;
  font-family: 'Josefin Sans', sans-serif;
}

.submit-button:hover {
  background: var(--color-gold-light);
  transform: translateY(-2px);
}

/* Required field indicator */
label[for]:has(+ [required])::after {
  content: " *";
  color: #DEB241;
}

/* Error states */
input:invalid,
select:invalid,
textarea:invalid {
  border-color: #DEB241;
}

/* Responsive Design */
@media (max-width: 768px) {
  .application-form {
    padding: 1.5rem;
  }

  .form-grid {
    grid-template-columns: 1fr;
  }

  .form-section {
    padding: 1rem;
  }

  .checkbox-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .application-form {
    padding: 1rem;
  }

  .form-header h2 {
    font-size: 1.75rem;
  }

  .form-section h3 {
    font-size: 1.25rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/styles/CareerForm.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;;;EAKE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;;;;;EAKE,aAAa;EACb,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,cAAc;AAChB;;AAEA,iBAAiB;AACjB;;;EAGE,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".application-form {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 2rem;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  font-family: 'Josefin Sans', sans-serif;\n}\n\n.form-header {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.form-header h2 {\n  font-size: 2rem;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 1rem;\n}\n\n.form-header p {\n  color: #666;\n  line-height: 1.6;\n}\n\n.form-section {\n  margin-bottom: 2rem;\n  padding: 2rem;\n  background: white;\n  border-radius: 8px;\n  border: 1px solid #eee;\n}\n\n.form-section h3 {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 1rem;\n  border-bottom: 2px solid #eee;\n  padding-bottom: 0.5rem;\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1.5rem;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-group.full-width {\n  grid-column: 1 / -1;\n}\n\nlabel {\n  font-weight: 500;\n  margin-bottom: 0.5rem;\n  color: #333;\n}\n\ninput[type=\"text\"],\ninput[type=\"email\"],\ninput[type=\"tel\"],\nselect,\ntextarea {\n  padding: 0.75rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 1rem;\n  font-family: 'Josefin Sans', sans-serif;\n  transition: border-color 0.3s ease;\n}\n\ninput[type=\"text\"]:focus,\ninput[type=\"email\"]:focus,\ninput[type=\"tel\"]:focus,\nselect:focus,\ntextarea:focus {\n  outline: none;\n  border-color: #DEB241;\n  box-shadow: 0 0 0 1px #DEB241;\n}\n\ntextarea {\n  width: 100%;\n  min-height: 120px;\n  padding: 1rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-family: 'Josefin Sans', sans-serif;\n  font-size: 1rem;\n  resize: vertical;\n}\n\n.checkbox-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.checkbox-group {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n}\n\n.checkbox-group input[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n  margin-top: 0.2rem;\n  border: 2px solid #ddd;\n  border-radius: 4px;\n  cursor: pointer;\n  accent-color: #526015;\n}\n\n.checkbox-group input[type=\"checkbox\"]:checked {\n  background-color: #526015;\n  border-color: #526015;\n}\n\n.checkbox-group input[type=\"checkbox\"]:checked + label {\n  color: #526015;\n  font-weight: 500;\n}\n\n.checkbox-group label {\n  font-weight: normal;\n  line-height: 1.5;\n  color: #333;\n  cursor: pointer;\n}\n\n.certification {\n  margin-top: 2rem;\n  padding: 1.5rem;\n  background: #f9f9f9;\n  border-radius: 4px;\n}\n\n.submit-button {\n  display: block;\n  width: 100%;\n  padding: 1rem;\n  background: var(--color-gold);\n  color: #333;\n  border: none;\n  border-radius: 25px;\n  font-size: 1.1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-top: 2rem;\n  font-family: 'Josefin Sans', sans-serif;\n}\n\n.submit-button:hover {\n  background: var(--color-gold-light);\n  transform: translateY(-2px);\n}\n\n/* Required field indicator */\nlabel[for]:has(+ [required])::after {\n  content: \" *\";\n  color: #DEB241;\n}\n\n/* Error states */\ninput:invalid,\nselect:invalid,\ntextarea:invalid {\n  border-color: #DEB241;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .application-form {\n    padding: 1.5rem;\n  }\n\n  .form-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .form-section {\n    padding: 1rem;\n  }\n\n  .checkbox-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 480px) {\n  .application-form {\n    padding: 1rem;\n  }\n\n  .form-header h2 {\n    font-size: 1.75rem;\n  }\n\n  .form-section h3 {\n    font-size: 1.25rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
